<!--
    Text Modal Component
    <text-modal-component></text-modal-component>
-->

<template>
    <div class="text-modal-component small">
        <div class="text-modal">
            <header class="modal-header">
                <slot name="header">
<!--                    <h3>default header</h3>-->
                </slot>
            </header>
            <section class="modal-body">
                <slot name="body">
                    <p>default body</p>
                </slot>
                <div class="text-center">
                  <button type="button" class="btn btn-outline-primary" @click="close">
                    Continue
                </button>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'modalTitle',
            'modalText'
        ],
        methods: {
            close() {
                this.$emit('close');
            },
        }
    }
</script>
